import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Modal,
    Box,
    TextField,
    Button,
    IconButton,
    Grid,
    Alert,
    AlertTitle,
    Card,
    Typography,
    Checkbox,
    FormControlLabel
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { makeStyles } from '@mui/styles';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import Autocomplete from '@mui/material/Autocomplete';
import planbusinessnameApi from '../../../services/product';
import getbusinessuuidApi from '../../../services/managelicense';
import commonApi from '../../../services/common';
import subscribeApi from '../../../services/subscribe';
import { useDispatch, useSelector } from 'react-redux';
import { showLoader, hideLoader } from '../../../redux/loader/actions';
import { showSnackbar } from '../../../redux/snackbar/actions';
import PricingModal from '../pricing';
import { setEncryptedCookie, getDecryptedCookie, removeCookie } from '../../../utils';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
const useStyles = makeStyles({
    customButton: {
        background: 'linear-gradient(45deg, #ff4b2b 30%, #ff416c 90%)',
        color: '#fff',
        borderRadius: '8px',
        boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.2)',
        textTransform: 'uppercase',
        fontWeight: 'bold',
        padding: '10px 24px',
        transition: 'all 0.4s ease',
        position: 'relative',
        overflow: 'hidden',
        '&:hover': {
            background: 'linear-gradient(45deg, #ff416c 30%, #ff4b2b 90%)',
            boxShadow: '0px 6px 16px rgba(0, 0, 0, 0.3)',
            transform: 'scale(1.05)'
        },
        '&:before': {
            content: '""',
            position: 'absolute',
            top: '-50%',
            left: '-50%',
            width: '200%',
            height: '200%',
            background: 'rgba(255, 255, 255, 0.15)',
            transform: 'rotate(45deg)',
            transition: 'all 0.7s ease',
            zIndex: 0
        },
        '&:hover:before': {
            top: '-30%',
            left: '-30%'
        },
        '& .MuiButton-label': {
            position: 'relative',
            zIndex: 1
        },
        '&:active': {
            transform: 'scale(0.98)',
            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.4)'
        },
        '& .MuiTouchRipple-root': {
            color: 'rgba(255, 255, 255, 0.3)'
        }
    },
    gridItemNoPaddingTop: {
        '& .css-mhc70k-MuiGrid-root > .MuiGrid-item': {
            paddingTop: 0
        }
    }
});

const BusinessDetails = ({
    open,
    onClose,
    trialMessage,
    onBackToPriceDetails,
    productDetails,
    setProductDetails,
    selectedPlanDetails,
    setSelectedPlanDetails,
    pricing,
    setPricing,
    setShowTrialDetails,
    actionType
}) => {
    const classes = useStyles();
    const organizationItems = useSelector((state) => state.organizationReducer.items);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [states, setStates] = useState([]);
    const [isPricingModalOpen, setIsPricingModalOpen] = useState(false);
    const [businessUUid, setBusinessUUid] = useState([]);

    const busId = getDecryptedCookie('bi');
    const proid = getDecryptedCookie('proid');

    const planBusinessName = useCallback(
        (values) => {
            // dispatch(showLoader());
            // if (!values.state) {
            //     dispatch(hideLoader());
            //     dispatch(
            //         showSnackbar({
            //             message: 'Please select a state',
            //             autoHideDuration: 3000,
            //             anchorOrigin: {
            //                 vertical: 'top',
            //                 horizontal: 'right'
            //             },
            //             variant: 'error'
            //         })
            //     );
            //     return;
            // }
            const data = {
                business_name: values.businessname,
                business_alias_name: values.businessaliasname,
                state_lookup_id: values.state,
                product_uuid: productDetails?.uuid || proid,
                business_gst: values.gstin,
                business_address: values.area,
                legal_entity_name: values.legal_entity,
                billing_address: values.billing_address
            };
            removeCookie('bi');
            removeCookie('print');
            removeCookie('buslap');
            const onSuccess = (res) => {
                dispatch(hideLoader());
                dispatch(
                    showSnackbar({
                        message: res?.data?.msg,
                        autoHideDuration: 3000,
                        anchorOrigin: {
                            vertical: 'top',
                            horizontal: 'right'
                        },
                        variant: 'success'
                    })
                );
                if (res.data.status === true) {
                    const newBusinessUuid = res?.data?.data?.business_uuid;
                    setBusinessUUid(newBusinessUuid);
                    setEncryptedCookie('bi', newBusinessUuid, { expires: 7 });

                    if (newBusinessUuid) {
                        setIsPricingModalOpen(true);
                        if (trialMessage) {
                            handlePaymentClick(newBusinessUuid);
                            onClose();
                        } else {
                            onClose();
                        }
                    }
                    setShowTrialDetails(false);
                } else {
                    console.error('Failed to fetch data');
                }
            };

            const onFailure = (err) => {
                dispatch(hideLoader());
                dispatch(
                    showSnackbar({
                        message: err?.response?.data?.msg,
                        autoHideDuration: 3000,
                        anchorOrigin: {
                            vertical: 'top',
                            horizontal: 'right'
                        },
                        variant: 'error'
                    })
                );
                console.error('Failed to fetch data', err);
            };

            planbusinessnameApi.planBusinessName(data).then(onSuccess).catch(onFailure);
        },
        [dispatch, onClose, trialMessage]
    );

    const handleBackToPriceDetails = () => {
        onBackToPriceDetails();
    };

    const stateList = useCallback(() => {
        dispatch(showLoader());

        const onSuccess = (res) => {
            dispatch(hideLoader());
            if (res.data.status === true) {
                setStates(res.data.data);
            } else {
                console.error('Failed to fetch data');
            }
        };

        const onFailure = (err) => {
            dispatch(hideLoader());
            console.error('Failed to fetch data', err);
        };

        commonApi.getAllState().then(onSuccess).catch(onFailure);
    }, [dispatch]);

    useEffect(() => {
        if (open) {
            stateList();
        }
    }, [stateList, open]);

    const formik = useFormik({
        initialValues: {
            businessname: '',
            businessaliasname: '',
            gstin: '',
            legal_entity: '',
            billing_address: '',
            area: '',
            state: '',
            check_legal_entity: false,
            check_billing_address: false
        },
        validationSchema: Yup.object().shape({
            gstin: Yup.string()
                .matches(/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{1}[Z]{1}[A-Z0-9]{1}$/, 'Invalid GST format')
                .length(15, 'GST must be exactly 15 characters long'),

            legal_entity: Yup.string().when('gstin', {
                is: (gstin) => gstin && gstin.length === 15,
                then: (schema) => schema.required('Legal entity name is required').min(3).max(100),
                otherwise: (schema) => schema.notRequired()
            }),

            billing_address: Yup.string().when('gstin', {
                is: (gstin) => gstin && gstin.length === 15,
                then: (schema) => schema.required('Billing address is required').min(20).max(250),
                otherwise: (schema) => schema.notRequired()
            }),

            state: Yup.string().required('Address is required'),

            area: Yup.string()
                .required('Address is required')
                .min(20, 'Address must be at least 20 characters')
                .max(250, 'Address must be at most 250 characters'),

            businessname: Yup.string()
                .min(3, 'Business name must be at least 3 characters')
                .max(100, 'Business name must not exceed 35 characters')
                .required('Business name is required'),

            businessaliasname: Yup.string()
                .min(3, 'Business alias must be at least 3 characters')
                .max(5, 'Business alias must not exceed 5 characters')
                .required('Business alias is required')
        }),
        onSubmit: (values) => {
            planBusinessName(values);
        }
    });

    const handlePaymentClick = (newBusinessUuid) => {
        dispatch(showLoader());
        removeCookie('buslap');
        const data = {
            business_uuid: newBusinessUuid || busId,
            prd_plan_pricing_uuid: '',
            renewal_type: 'none',
            subscription_type: actionType,
            purchase_type: 'new',
            product_plan_uuid: selectedPlanDetails?.product_plan_uuid,
            total_amount: 0,
            offer_uuid: '',
            offer_type: ''
        };

        const onSuccess = (res) => {
            dispatch(hideLoader());
            dispatch(
                showSnackbar({
                    message: res?.data?.msg,
                    autoHideDuration: 3000,
                    anchorOrigin: {
                        vertical: 'top',
                        horizontal: 'right'
                    },
                    variant: 'success'
                })
            );
            setEncryptedCookie('buslap', newBusinessUuid || busId, { expires: 7 });
            getbusinessuuid(proid, newBusinessUuid || busId);
            navigate(`/subscriptions/manageproducts/productconfig/${proid}/${newBusinessUuid || busId}`);
        };

        const onFailure = (err) => {
            dispatch(hideLoader());
            dispatch(
                showSnackbar({
                    message: err?.response?.data?.msg,
                    autoHideDuration: 3000,
                    anchorOrigin: {
                        vertical: 'top',
                        horizontal: 'right'
                    },
                    variant: 'error'
                })
            );
            console.error('Failed', err);
        };

        subscribeApi.createSubscription(data).then(onSuccess, onFailure);
    };

    const getbusinessuuid = useCallback((proid, business_uuid) => {
        removeCookie('bss');
        dispatch(showLoader());
        const onSuccess = (res) => {
            dispatch(hideLoader());
            if (res.data.status) {
                setEncryptedCookie('bss', res?.data?.data?.data[0]?.business_uuid);
            }
        };

        const onFailure = (err) => {
            dispatch(hideLoader());
            console.error('Failed to fetch data', err);
        };

        getbusinessuuidApi.getbusinessId(proid, business_uuid).then(onSuccess).catch(onFailure);
    }, []);

    const [selectedCard, setSelectedCard] = useState(null);

    const handleCardClick = (index) => {
        setSelectedCard(index);
    };

    return (
        <>
            <Modal
                open={open}
                onClose={(event, reason) => {
                    if (reason !== 'backdropClick') {
                        onClose();
                    }
                }}
                sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.3)' } }}
            >
                <Box
                    sx={{
                        bgcolor: 'background.paper',
                        p: 4,
                        borderRadius: 1,
                        boxShadow: 24,
                        outline: 'none',
                        position: 'relative',
                        width: {
                            xs: '79%',
                            sm: '70%',
                            md: '90%'
                        },
                        maxHeight: '80vh',
                        overflowY: 'auto'
                    }}
                >
                    <IconButton
                        onClick={() => {
                            onClose();
                            formik?.resetForm();
                        }}
                        sx={{
                            position: 'absolute',
                            top: 8,
                            right: 8,
                            zIndex: 1
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                    <form onSubmit={formik.handleSubmit}>
                        <Grid container spacing={2} mt={1} className={classes.gridItemNoPaddingTop}>
                            <Grid item xs={12}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={6} md={3}>
                                        <TextField
                                            fullWidth
                                            label='Business Name'
                                            name='businessname'
                                            value={formik.values.businessname}
                                            onChange={formik.handleChange}
                                            error={formik.touched.businessname && Boolean(formik.errors.businessname)}
                                            helperText={formik.touched.businessname && formik.errors.businessname}
                                            sx={{ mb: 2 }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3}>
                                        <TextField
                                            fullWidth
                                            label='Business Alias Name'
                                            name='businessaliasname'
                                            value={formik.values.businessaliasname}
                                            onChange={formik.handleChange}
                                            error={
                                                formik.touched.businessaliasname &&
                                                Boolean(formik.errors.businessaliasname)
                                            }
                                            helperText={
                                                formik.touched.businessaliasname && formik.errors.businessaliasname
                                            }
                                            sx={{ mb: 2 }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3}>
                                        <TextField
                                            label='Address'
                                            fullWidth
                                            value={formik.values.area}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            name='area'
                                            error={formik.touched.area && Boolean(formik.errors.area)}
                                            helperText={formik.touched.area && formik.errors.area}
                                            sx={{ mb: 2 }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3}>
                                        <Autocomplete
                                            options={states}
                                            getOptionLabel={(option) => option.value}
                                            onChange={(event, newValue) => {
                                                formik.setFieldValue('state', newValue ? newValue.state_lookup_id : '');
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label='State'
                                                    error={formik.touched.state && Boolean(formik.errors.state)}
                                                    helperText={formik.touched.state && formik.errors.state}
                                                    sx={{ mb: 1 }}
                                                />
                                            )}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3}>
                                        <TextField
                                            label='GST IN'
                                            fullWidth
                                            value={formik.values.gstin}
                                            onChange={(e) => {
                                                formik.handleChange(e);
                                                formik.setFieldValue('legal_entity', '');
                                                formik.setFieldValue('check_legal_entity', false);
                                                formik.setFieldValue('billing_address', '');
                                                formik.setFieldValue('check_billing_address', false);
                                            }}
                                            onBlur={formik.handleBlur}
                                            name='gstin'
                                            error={formik.touched.gstin && Boolean(formik.errors.gstin)}
                                            helperText={formik.touched.gstin && formik.errors.gstin}
                                            sx={{ mb: 2 }}
                                        />
                                    </Grid>
                                    {formik.values.gstin && !formik.errors.gstin && (
                                        <>
                                            <Grid item xs={12} sm={6} md={3}>
                                                <TextField
                                                    label='Name of Legal Entity'
                                                    fullWidth
                                                    value={formik.values.legal_entity}
                                                    onChange={(e) => {
                                                        formik.handleChange(e);
                                                        formik.setFieldValue('check_legal_entity', false);
                                                    }}
                                                    onBlur={formik.handleBlur}
                                                    name='legal_entity'
                                                    error={
                                                        formik.touched.legal_entity &&
                                                        Boolean(formik.errors.legal_entity)
                                                    }
                                                    helperText={
                                                        formik.touched.legal_entity && formik.errors.legal_entity
                                                    }
                                                    sx={{ mb: 1 }}
                                                />
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            name='check_legal_entity'
                                                            checked={
                                                                formik.values.check_legal_entity ||
                                                                formik.values.legal_entity ===
                                                                    formik.values.businessname
                                                            }
                                                            onChange={(e) => {
                                                                const isChecked = e.target.checked;
                                                                formik.setFieldValue('check_legal_entity', isChecked);
                                                                if (isChecked) {
                                                                    formik.setFieldValue(
                                                                        'legal_entity',
                                                                        formik.values.businessname
                                                                    );
                                                                } else {
                                                                    formik.setFieldValue('legal_entity', '');
                                                                }
                                                            }}
                                                        />
                                                    }
                                                    labelPlacement='end'
                                                    label={
                                                        <Typography
                                                            sx={{
                                                                fontSize: {
                                                                    xs: '12px',
                                                                    sm: '14px',
                                                                    md: '11px',
                                                                    lg: '13.7px'
                                                                }
                                                            }}
                                                        >
                                                            {' '}
                                                            Same as Business Name{' '}
                                                        </Typography>
                                                    }
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={3}>
                                                <TextField
                                                    label='Billing Address'
                                                    fullWidth
                                                    value={formik.values.billing_address}
                                                    onChange={(e) => {
                                                        formik.handleChange(e);
                                                        formik.setFieldValue('check_billing_address', false);
                                                    }}
                                                    onBlur={formik.handleBlur}
                                                    name='billing_address'
                                                    error={
                                                        formik.touched.billing_address &&
                                                        Boolean(formik.errors.billing_address)
                                                    }
                                                    helperText={
                                                        formik.touched.billing_address && formik.errors.billing_address
                                                    }
                                                    sx={{ mb: 1 }}
                                                />
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            name='check_billing_address'
                                                            checked={
                                                                formik.values.check_billing_address ||
                                                                formik.values.billing_address === formik.values.area
                                                            }
                                                            onChange={(e) => {
                                                                const isChecked = e.target.checked;
                                                                formik.setFieldValue(
                                                                    'check_billing_address',
                                                                    isChecked
                                                                );
                                                                if (isChecked) {
                                                                    formik.setFieldValue(
                                                                        'billing_address',
                                                                        formik.values.area
                                                                    );
                                                                } else {
                                                                    formik.setFieldValue('billing_address', '');
                                                                }
                                                            }}
                                                        />
                                                    }
                                                    labelPlacement='end'
                                                    label={
                                                        <Typography
                                                            sx={{
                                                                fontSize: {
                                                                    xs: '12px',
                                                                    sm: '14px',
                                                                    md: '11px',
                                                                    lg: '13.7px'
                                                                }
                                                            }}
                                                        >
                                                            {' '}
                                                            Same as Address{' '}
                                                        </Typography>
                                                    }
                                                />
                                            </Grid>
                                        </>
                                    )}
                                </Grid>
                            </Grid>
                        </Grid>
                        {/* ALERT */}
                        <Alert severity='info' sx={{ mb: 2, my: 2 }}>
                            <AlertTitle>Your Brand, Your Legacy</AlertTitle>
                            Business name and Business alias name are permanent and cannot be changed after
                            subscription.
                        </Alert>
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'flex-end',
                                mt: 2
                            }}
                        >
                            {trialMessage ? null : (
                                <Button
                                    variant='outlined'
                                    sx={{
                                        marginRight: '8px',
                                        width: {
                                            xs: '228px',
                                            sm: 'auto',
                                            md: 'auto'
                                        },
                                        height: {
                                            xs: '51px',
                                            sm: 'auto',
                                            md: 'auto'
                                        },

                                        fontSize: {
                                            xs: '10px',
                                            sm: '14px',
                                            md: '15px'
                                        },
                                        padding: {
                                            xs: '6px 16px',
                                            sm: '8px 20px',
                                            md: '10px 24px'
                                        }
                                    }}
                                    onClick={handleBackToPriceDetails}
                                >
                                    Back to Price Details
                                </Button>
                            )}

                            <Button
                                type='submit'
                                variant='contained'
                                color='primary'
                                startIcon={<PlayArrowIcon />}
                                className={classes.customButton}
                                sx={{
                                    width: {
                                        xs: '228px',
                                        sm: 'auto',
                                        md: 'auto'
                                    },
                                    height: {
                                        xs: '51px',
                                        sm: 'auto',
                                        md: 'auto'
                                    },

                                    fontSize: {
                                        xs: '10px',
                                        sm: '14px',
                                        md: '15px'
                                    },
                                    padding: {
                                        xs: '6px 16px',
                                        sm: '8px 20px',
                                        md: '10px 24px'
                                    }
                                }}
                            >
                                {trialMessage ? 'Launch Trial' : ' Start Your Journey'}
                            </Button>
                        </Box>
                    </form>
                </Box>
            </Modal>

            <PricingModal
                open={isPricingModalOpen}
                onClose={() => setIsPricingModalOpen(false)}
                productDetails={productDetails}
                setProductDetails={setProductDetails}
                selectedPlanDetails={selectedPlanDetails}
                setSelectedPlanDetails={setSelectedPlanDetails}
                pricing={pricing}
                setPricing={setPricing}
                setShowTrialDetails={setShowTrialDetails}
                actionType={actionType}
            />
        </>
    );
};

export default BusinessDetails;
